 
import React, { FC } from 'react';
import { SActions } from './styles';
import UpdateTaskButton from './UpdateTaskButton';
import DeleteTaskButton from './DeleteTaskButton';
import { useTaskById } from 'core/api/tasks';

type TaskActionsProps = {
    taskId: string;
};

const TaskActions: FC<TaskActionsProps> = ({ taskId }) => {
    const task = useTaskById(taskId).data;

    if (!task) {
        return null;
    }

    return (
        <SActions>
            <UpdateTaskButton taskId={taskId} />
            <DeleteTaskButton taskId={taskId} />
        </SActions>
    );
};

export default TaskActions;
